"use client";

import Link from "next/link";
import SectionHeader from "@/components/ui/section-header";
import { ArrowRight } from "@/components/icons";
import { buttonVariants } from "@/components/ui/button";
import { ROUTES } from "@/lib/constants";
import { BUYING_FACTORS } from "./data";

export default function UseCasesBuyingGuide() {
  return (
    <section
      className="py-section-sm border-border border-b"
      aria-labelledby="use-cases-buying-guide-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="border-border bg-muted/20 rounded-2xl border p-6 sm:p-10">
          <div className="max-w-2xl">
            <SectionHeader
              eyebrow="Before You Buy"
              id="use-cases-buying-guide-heading"
              heading="Five factors that decide what infrastructure you need"
              body="Work through these before comparing products or pricing."
              headingClassName="scroll-mt-40"
            />
          </div>

          <ol className="mt-8 grid list-none grid-cols-1 gap-4 sm:grid-cols-2">
            {BUYING_FACTORS.map((factor, i) => (
              <li
                key={factor.title}
                className="border-border bg-card flex items-start gap-3.5 rounded-xl border p-5"
              >
                <span
                  className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold tabular-nums"
                  style={{
                    background: "color-mix(in srgb, var(--brand-green) 8%, transparent)",
                    color: "var(--brand-green)",
                    border: "1px solid color-mix(in srgb, var(--brand-green) 20%, transparent)",
                  }}
                >
                  {i + 1}
                </span>
                <span className="text-muted-foreground pt-0.5 text-sm leading-relaxed">
                  <strong className="text-foreground font-semibold">{factor.title}:</strong>{" "}
                  {factor.body}
                </span>
              </li>
            ))}
          </ol>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              href={ROUTES.productResidentialProxies}
              className={buttonVariants({ variant: "default", size: "lg" })}
            >
              Explore Residential Proxies
              <ArrowRight size={16} aria-hidden="true" />
            </Link>
            <Link
              href={ROUTES.productMobileProxies}
              className={buttonVariants({ variant: "secondary", size: "lg" })}
            >
              Explore Mobile Proxies
            </Link>
            <Link
              href={ROUTES.pricing}
              className={buttonVariants({ variant: "secondary", size: "lg" })}
            >
              Compare Pricing
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
